import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { useAuth } from './AuthContext';
import api from './axios';
import './ConfigCompany.css';
import './App.css';
import logo from './Logo iAnalytics.png';

export default function ResetPassword() {
  const { companyId } = useAuth();
  const { token }     = useParams();
  const navigate      = useNavigate();

  const [newPassword, setNewPassword]       = useState('');
  const [showPassword, setShowPassword]     = useState(false);
  const [showPopupMessage, setShowPopupMessage] = useState(false);
  const [message, setMessage]               = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [error, setError]                   = useState('');

  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#]).{8,}$/;

  const togglePasswordVisibility = () =>
    setShowPassword(v => !v);

  const handleResetPassword = async evt => {
    evt.preventDefault();

    if (!passwordRegex.test(newPassword)) {
      setError(
        "Password must be at least 8 characters, include one uppercase letter, one digit, and one special character."
      );
      setShowErrorPopup(true);
      setTimeout(() => setShowErrorPopup(false), 3000);
      return;
    }

    try {
      const { data } = await api.post('/api/change-password', {
        token,
        newPassword
      });

      if (data.success) {
        setMessage('Password updated successfully! Redirecting to login…');
        setShowPopupMessage(true);
        setTimeout(() => {
          setShowPopupMessage(false);
          navigate(`/login/${companyId}`);
        }, 3000);
      } else {
        throw new Error(data.error || 'Unknown error');
      }
    } catch (err) {
      const msg =
        err.response?.data?.error ||
        err.message ||
        'An unexpected error occurred';
      setError(`Updating password failed: ${msg}`);
      setShowErrorPopup(true);
      setTimeout(() => setShowErrorPopup(false), 3000);
      console.error(err);
    }
  };

  // Als er geen token in de URL zit, tonen we niets
  if (!token) return null;

  return (
    <CSSTransition in={true} timeout={300} classNames="fade" unmountOnExit>
      <div className="page">
        <div className="popup-container">
          <div className="popup-content">
            <img src={logo} alt="Company Logo" className="logo" />
            <h2 style={{ fontWeight: 'normal' }}>Reset Password</h2>
            <div className="white-space" />
            <form onSubmit={handleResetPassword}>
              <div className="password-input">
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="New password *"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="show-hide-button"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
              <div className="white-space" />
              <div>
                <button
                  type="submit"
                  className={`button-resetpassword ${
                    newPassword ? 'active' : ''
                  }`}
                  disabled={!newPassword}
                >
                  Reset password
                </button>
              </div>
            </form>
          </div>
        </div>

        {showPopupMessage && (
          <div className="popup-message">{message}</div>
        )}
        {showErrorPopup && <div className="popup">{error}</div>}
      </div>
    </CSSTransition>
  );
}
